const ActionTypes = {
  INDEX: "INDEX",
  DISPATCH_USER: "DISPATCH_USER",
  LOGIN_USER: "LOGIN_USER",
  LOGOUT_USER: "LOGOUT_USER",
  SAVE_FILTERS: "SAVE_FILTERS",
  SAVE_SELECTED_FILTERS: "SAVE_SELECTED_FILTERS",
  SAVE_CART_DETAILS: "SAVE_CART_DETAILS",
  ADD_ENTRY: "ADD_ENTRY",
  SAVE_CURRENT_ENTRY: "SAVE_CURRENT_ENTRY",
  ADD_TO_TOTAL_AMOUNT: "ADD_TO_TOTAL_AMOUNT",
  SET_TOTAL_AMOUNT: "SET_TOTAL_AMOUNT",
  SET_ENTRIES: "SET_ENTRIES",
  RESET_TOTAL_AMOUNT: "RESET_TOTAL_AMOUNT",
  REMOVE_ENTRY: "REMOVE_ENTRY",
  HAS_ITEMS: "HAS_ITEMS",
  UPDATE_BUNDLE_QUANTITY: "UPDATE_BUNDLE_QUANTITY",
  RESET_BUNDLE_QUANTITY: "RESET_BUNDLE_QUANTITY",
  USER_SESSION_FOR_BUNDLES: "USER_SESSION_FOR_BUNDLES",
  // Countries actions
  SET_COUNTRIES: "SET_COUNTRIES",
  SET_COUNTRIES_LOADING: "SET_COUNTRIES_LOADING",
  SET_COUNTRIES_ERROR: "SET_COUNTRIES_ERROR",
  CLEAR_COUNTRIES: "CLEAR_COUNTRIES",
  // Currencies actions
  SET_CURRENCIES: "SET_CURRENCIES",
  SET_CURRENCIES_LOADING: "SET_CURRENCIES_LOADING",
  SET_CURRENCIES_ERROR: "SET_CURRENCIES_ERROR",
  CLEAR_CURRENCIES: "CLEAR_CURRENCIES",
  // Service Categories actions
  SET_SERVICE_CATEGORIES: "SET_SERVICE_CATEGORIES",
  SET_SERVICE_CATEGORIES_LOADING: "SET_SERVICE_CATEGORIES_LOADING",
  SET_SERVICE_CATEGORIES_ERROR: "SET_SERVICE_CATEGORIES_ERROR",
  CLEAR_SERVICE_CATEGORIES: "CLEAR_SERVICE_CATEGORIES",
  // Service Subcategories actions
  SET_SERVICE_SUBCATEGORIES: "SET_SERVICE_SUBCATEGORIES",
  SET_SERVICE_SUBCATEGORIES_LOADING: "SET_SERVICE_SUBCATEGORIES_LOADING",
  SET_SERVICE_SUBCATEGORIES_ERROR: "SET_SERVICE_SUBCATEGORIES_ERROR",
  CLEAR_SERVICE_SUBCATEGORIES: "CLEAR_SERVICE_SUBCATEGORIES",
  // Amenities actions
  SET_AMENITIES: "SET_AMENITIES",
  SET_AMENITIES_LOADING: "SET_AMENITIES_LOADING",
  SET_AMENITIES_ERROR: "SET_AMENITIES_ERROR",
  CLEAR_AMENITIES: "CLEAR_AMENITIES",
  // Subscription actions
  SET_SUBSCRIPTIONS: "SET_SUBSCRIPTIONS",
  SET_SUBSCRIPTIONS_LOADING: "SET_SUBSCRIPTIONS_LOADING",
  SET_SUBSCRIPTIONS_ERROR: "SET_SUBSCRIPTIONS_ERROR",
  CLEAR_SUBSCRIPTIONS: "CLEAR_SUBSCRIPTIONS",
  SET_ACTIVE_SUBSCRIPTION: "SET_ACTIVE_SUBSCRIPTION",
  SET_SUBSCRIPTION_WALL_CHECKED: "SET_SUBSCRIPTION_WALL_CHECKED",
  // Feature flags actions
  SET_FEATURE_FLAGS: "SET_FEATURE_FLAGS",
  SET_FEATURE_FLAGS_LOADING: "SET_FEATURE_FLAGS_LOADING",
  SET_FEATURE_FLAGS_ERROR: "SET_FEATURE_FLAGS_ERROR",
  CLEAR_FEATURE_FLAGS: "CLEAR_FEATURE_FLAGS",
  // Applicable package actions
  SET_APPLICABLE_PACKAGE: "SET_APPLICABLE_PACKAGE",
  SET_APPLICABLE_PACKAGE_LOADING: "SET_APPLICABLE_PACKAGE_LOADING",
  SET_APPLICABLE_PACKAGE_ERROR: "SET_APPLICABLE_PACKAGE_ERROR",
  CLEAR_APPLICABLE_PACKAGE: "CLEAR_APPLICABLE_PACKAGE",
  // Organization Roles actions
  SET_ORGANIZATION_ROLES: "SET_ORGANIZATION_ROLES",
  SET_ORGANIZATION_ROLES_LOADING: "SET_ORGANIZATION_ROLES_LOADING",
  SET_ORGANIZATION_ROLES_ERROR: "SET_ORGANIZATION_ROLES_ERROR",
  CLEAR_ORGANIZATION_ROLES: "CLEAR_ORGANIZATION_ROLES",
  // Payment Institutions actions
  SET_PAYMENT_INSTITUTIONS: "SET_PAYMENT_INSTITUTIONS",
  SET_PAYMENT_INSTITUTIONS_LOADING: "SET_PAYMENT_INSTITUTIONS_LOADING",
  SET_PAYMENT_INSTITUTIONS_ERROR: "SET_PAYMENT_INSTITUTIONS_ERROR",
  CLEAR_PAYMENT_INSTITUTIONS: "CLEAR_PAYMENT_INSTITUTIONS",
  // Payment Setup actions
  SET_PAYMENT_SETUPS: "SET_PAYMENT_SETUPS",
  SET_PAYMENT_SETUP_LOADING: "SET_PAYMENT_SETUP_LOADING",
  SET_PAYMENT_SETUP_ERROR: "SET_PAYMENT_SETUP_ERROR",
  CLEAR_PAYMENT_SETUPS: "CLEAR_PAYMENT_SETUPS",
  SET_PAYMENT_SETUP_WALL_CHECKED: "SET_PAYMENT_SETUP_WALL_CHECKED",
};

export default ActionTypes;
